var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.22222 0H17.7778C19.0051 0 20 0.994923 20 2.22222C20 3.44952 19.0051 4.44444 17.7778 4.44444H2.22222C0.994923 4.44444 0 3.44952 0 2.22222C0 0.994923 0.994923 0 2.22222 0ZM5.55556 6.66667H14.4444C15.6717 6.66667 16.6667 7.66159 16.6667 8.88889C16.6667 10.1162 15.6717 11.1111 14.4444 11.1111H5.55556C4.32826 11.1111 3.33333 10.1162 3.33333 8.88889C3.33333 7.66159 4.32826 6.66667 5.55556 6.66667ZM8.88889 13.3333H11.1111C12.3384 13.3333 13.3333 14.3283 13.3333 15.5556C13.3333 16.7829 12.3384 17.7778 11.1111 17.7778H8.88889C7.66159 17.7778 6.66667 16.7829 6.66667 15.5556C6.66667 14.3283 7.66159 13.3333 8.88889 13.3333Z",
    fill: "#0262B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.67dee9576713f870ffd788f62d0f7a63.svg";
export { ForwardRef as ReactComponent };